import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const;
const STORAGE_KEY = 'firstTouchUTM';

export const UTMPersistence: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Only capture UTM params on first visit
    if (localStorage.getItem(STORAGE_KEY)) {
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const utmParams: Record<string, string> = {};
    let hasUTMParams = false;

    UTM_PARAMS.forEach(param => {
      const value = searchParams.get(param);
      if (value) {
        utmParams[param] = value;
        hasUTMParams = true;
      }
    });

    if (hasUTMParams) {
      const utmData = {
        ...utmParams,
        firstVisit: new Date().toISOString(),
        landingPage: location.pathname + location.search
      };
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
      console.log('First-touch UTM params captured:', utmData);
    }
  }, [location]);

  return null;
};

// Helper function to get UTM data
export const getUTMData = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved ? JSON.parse(saved) : null;
};